import { render, staticRenderFns } from "./PruneSlider.vue?vue&type=template&id=56a19cea&"
import script from "./PruneSlider.vue?vue&type=script&lang=js&"
export * from "./PruneSlider.vue?vue&type=script&lang=js&"
import style0 from "./PruneSlider.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports